import {ACTION_CODE} from './_actionCode';
import {DashboardService} from '../../../services';
import {ErrorModel, ResultModel} from '../../../models';
import {LoggerService} from '../../../services';
const FUNCTION_CODE = 'GET_RESULTS';

export async function getResults(userData: Record<string, any>, params: string) {
    try {
        LoggerService.logInfo('Action - getResults - Start');

        const getResults =
            await DashboardService.CodevService.getResults(userData, params);

        LoggerService.logInfo('Action - getResults - End - Success');

        return ResultModel.newSuccessResult(getResults);
    }
    catch (error) {
        LoggerService.logInfo('Action - getResults - End - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
